<template>
  <section id="FAQ" class="section">
    <div class="section-header js-section-header">
      <h2>FAQ</h2>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-12 col-md-6">
          <div class="card">
            <div class="card-body">
              <h5 class="card-title">Hvornår slutter tilmeldingen?</h5>
              <p class="card-text">
                I kan tilmelde jer på nettet indtil onsdag inden løbet, så jeres
                indbetaling kan nå at blive registreret fredag. I kan tilmelde
                jer på dagen mellem 16.30 og 17.30. ekstra gebyr for tilmelding
                på dagen kr. 75 pr. hold.
              </p>
              <hr />
              <h5 class="card-title">
                Skal jeg kunne bruge et kort for at deltage?
              </h5>
              <p class="card-text">
                Nej, hele ruten er tydelig afmærket.
              </p>
              <hr />
              <h5 class="card-title">Hvor skal jeg hente mit startnummer?</h5>
              <p class="card-text">
                Startnumre afhentes ½ time før start i teltet på å-siden af
                Musikteatret i Holstebro.
              </p>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6">
          <div class="card">
            <div class="card-body">
              <h5 class="card-title">Skal jeg kunne svømme?</h5>
              <p class="card-text">
                Ja, man skal kunne svømme 20 meter uden hjælp.
              </p>
              <hr />
              <h5 class="card-title">
                Kan jeg klare de udfordringer der er under løbet?
              </h5>
              <p class="card-text">
                Ja, alle vil kunne klare de små sjove udfordringer der er under
                løbet. De stiller ingen særlige krav ud over lyst til et løb med
                kant og natur.
              </p>
              <hr />
              <h5 class="card-title">Hvornår?</h5>
              <p class="card-text">
                {{ this.$root.datetime.day }} d.
                {{ this.$root.datetime.dateString }} kl.
                {{firstStart}} går den første
                start.
              </p>
              <hr />
              <h5 class="card-title">Hvor går starten?</h5>
              <p class="card-text">
                På å-siden (nord) af Musikteatret i centrum af Holstebro.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: "FAQ",
  computed: {
    firstStart: function () {
      const long = parseInt( this.$root.eventData.routes.long.time.replace( ':', '' ) );
      const short = parseInt( this.$root.eventData.routes.short.time.replace( ':', '' ) );

      if ( long > short ) {
        return this.$root.eventData.routes.short.time;
      } else {
        return this.$root.eventData.routes.long.time;
      }


    },

  },
};
</script>
<style lang="scss" scoped>
.section {
  background-image: linear-gradient(#b2e5ba, #9fdfa9);
}
</style>